import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bulk-change-eta" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "info__item" }
const _hoisted_5 = { class: "info__label" }
const _hoisted_6 = { class: "info__body" }
const _hoisted_7 = { class: "info__value" }
const _hoisted_8 = { class: "info__item" }
const _hoisted_9 = { class: "info__label" }
const _hoisted_10 = { class: "info__value" }
const _hoisted_11 = { class: "info__value--big" }
const _hoisted_12 = { class: "info__value--unit" }
const _hoisted_13 = { class: "info__item" }
const _hoisted_14 = { class: "info__label" }
const _hoisted_15 = { class: "info__value" }
const _hoisted_16 = { class: "info__value--big" }
const _hoisted_17 = { class: "info__value--unit" }
const _hoisted_18 = { class: "info__item" }
const _hoisted_19 = { class: "info__label" }
const _hoisted_20 = { class: "info__value" }
const _hoisted_21 = { class: "info__value--big" }
const _hoisted_22 = { class: "info__value--unit" }
const _hoisted_23 = { class: "section" }
const _hoisted_24 = { class: "group" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "group__name" }
const _hoisted_27 = { class: "group__eta" }
const _hoisted_28 = { class: "section" }
const _hoisted_29 = { class: "selected" }
const _hoisted_30 = { class: "detail" }
const _hoisted_31 = { class: "detail__item" }
const _hoisted_32 = { class: "detail__label" }
const _hoisted_33 = { class: "detail__value" }
const _hoisted_34 = { class: "detail__item" }
const _hoisted_35 = { class: "detail__label" }
const _hoisted_36 = { class: "detail__value" }
const _hoisted_37 = { class: "detail__item" }
const _hoisted_38 = { class: "detail__label" }
const _hoisted_39 = { class: "detail__value" }
const _hoisted_40 = { class: "detail__item" }
const _hoisted_41 = { class: "detail__label" }
const _hoisted_42 = { class: "detail__value" }
const _hoisted_43 = { class: "detail__item" }
const _hoisted_44 = { class: "detail__label" }
const _hoisted_45 = { class: "detail__value" }
const _hoisted_46 = { class: "detail__item" }
const _hoisted_47 = { class: "detail__label" }
const _hoisted_48 = { class: "detail__value" }
const _hoisted_49 = { class: "table" }

import { diContainer } from '@/coreContainer/container';
import { IOrderGroup } from '@/coreDomainsModule/entities/IOrderGroup';
import { Order } from '@/coreDomainsModule/entities/order';
import { initPagingOptions } from '@/coreDomainsModule/paging';
import { DateService } from '@/coreDomainsModule/services/dateService';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import { LoadingStatus, loadingStatusHelpers } from '@/corePagesModule/components/ezTable/types';
import { i18n } from '@/i18n';
import { OrderGroupService } from '@/orderTableModule/domains/service/orderGroupService';
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupBulkChangeMultipleETAModalContent',
  props: {
    changedETA: {},
    changeOrderCount: {},
    changeOrderWithGroupCount: {},
    targetOrderGroups: {}
  },
  setup(__props: any) {

const t = i18n.t;

const gridTemplateColumns: string[] = ['124px', '124px', '124px', '124px', '124px', '124px', '75px', '124px'];

const props = __props;

const selectedOrderGroupId = ref<string | undefined>(undefined);
const items = ref<Order[]>([]);
const loadingStatus = ref<LoadingStatus>({ type: 'loading' });

const selectedOrderGroup = computed(() =>
  selectedOrderGroupId.value ? props.targetOrderGroups.find((group) => group.orderGroupId === selectedOrderGroupId.value) : undefined
);

const additionalChangeOrderCount = computed(
  () => props.targetOrderGroups.reduce((acc, cur) => (acc += cur.linkedOrderCount), 0) - props.changeOrderWithGroupCount
);

/**
 * fetchとinitialization
 */
const fetchAndInitItem = async () => {
  if (!selectedOrderGroupId.value) return;
  const { loadingStatus: fetchLoadingStatus, items: fetchItems } = await _fetchOrderLinkedTargetOrderGroup(selectedOrderGroupId.value);
  loadingStatus.value = fetchLoadingStatus;
  if (!loadingStatusHelpers.isError(fetchLoadingStatus) && fetchItems) {
    items.value = fetchItems;
  }
};

/**
 * 対象の発注グループに紐づく発注を取得する
 * @param orderGroupId - 対象の発注グループID
 */
const _fetchOrderLinkedTargetOrderGroup = async (orderGroupId: string): Promise<{ loadingStatus: LoadingStatus; items?: Order[] }> => {
  if (!selectedOrderGroupId.value) return { loadingStatus: { type: 'error' }, items: undefined };
  const useFilterItems = [OrderGroupService.getFilterContentItem(selectedOrderGroupId.value)];
  const result = await diContainer.getUnorderedArrivalUseCase.Execute(false, initPagingOptions(100), 'orderId', true, useFilterItems, {
    ApprovedAwaitingDeliveryDate: true,
    QuantityConfirmed: true,
    DeliveryDateConfirmed: true,
    PartialDelivery: true,
    Confirmed: true,
    Delivered: true,
    DeliveryDelayed: true,
    ApprovalRequested: false,
  });
  let loadingStatus: LoadingStatus = { type: 'loading' };
  switch (result.status.type) {
    case 'success':
      if ((result.status.data.pagingOptions?.returnCount ?? 0) === 0) {
        loadingStatus = { type: 'zero-match' };
      } else {
        loadingStatus = { type: 'success' };
      }
      return {
        loadingStatus,
        items: result.status.data.result,
      };
    case 'error':
      loadingStatus = {
        type: 'error',
        errorMessage: '取得に失敗しました',
      };
      return {
        loadingStatus,
      };
  }
};

/**
 * 積載率を計算する
 * @param totalAmount - 合計発注数
 * @param upperLimitQuantity - 上限発注数
 */
const getLoadFactor = (totalAmount?: number, upperLimitQuantity?: number) => {
  console.log(totalAmount, upperLimitQuantity);
  if (!totalAmount || !upperLimitQuantity) return '0';
  const loadFactorValue = (totalAmount / upperLimitQuantity) * 100;
  return loadFactorValue.roundToDecimal(1);
};

/**
 * 発注グループを選択した際の挙動
 * @param selected - a
 */
const selectOrderGroup = async (selected: string) => {
  selectedOrderGroupId.value = selected;
  await fetchAndInitItem();
};

watch(
  () => props.targetOrderGroups,
  async () => {
    selectedOrderGroupId.value = props.targetOrderGroups[0]?.orderGroupId;
    await fetchAndInitItem();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('変更情報')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('納期')), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SvgLoader, { name: "calendar_today_gray2x" }),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(props.changedETA)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('選択されている発注')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(props.changeOrderCount), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('件')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('紐づいているグループ')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(props.targetOrderGroups.length), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('件')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('追加で変更される発注')), 1),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(additionalChangeOrderCount.value), 1),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('件')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('グループ情報')), 1),
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.targetOrderGroups, (orderGroup, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: _normalizeClass(["group__card", { group__card__active: selectedOrderGroupId.value === orderGroup.orderGroupId }]),
            onClick: () => selectOrderGroup(orderGroup.orderGroupId)
          }, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(orderGroup.orderGroupName), 1),
            _createElementVNode("div", _hoisted_27, _toDisplayString(`${_unref(t)('納期')}: ${orderGroup.eta ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(orderGroup.eta) : '--'}`), 1)
          ], 10, _hoisted_25))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('選択した発注グループの詳細')), 1),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('発注グループ名')), 1),
            _createElementVNode("div", _hoisted_33, _toDisplayString(selectedOrderGroup.value?.orderGroupName), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('納期')), 1),
            _createElementVNode("div", _hoisted_36, _toDisplayString(selectedOrderGroup.value?.eta ? _unref(DateService).convertMSUnixTimeToYYYYMMDDSlash(selectedOrderGroup.value?.eta) : '--'), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('発注件数')), 1),
            _createElementVNode("div", _hoisted_39, _toDisplayString(selectedOrderGroup.value?.linkedOrderCount), 1)
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('上限数量')), 1),
            _createElementVNode("div", _hoisted_42, _toDisplayString(selectedOrderGroup.value?.upperLimitQuantity?.addComma()), 1)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('発注合計数量')), 1),
            _createElementVNode("div", _hoisted_45, _toDisplayString(selectedOrderGroup.value?.totalLinkedOrderAmount?.addComma()), 1)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('積載率')), 1),
            _createElementVNode("div", _hoisted_48, _toDisplayString(`${getLoadFactor(selectedOrderGroup.value?.totalLinkedOrderAmount, selectedOrderGroup.value?.upperLimitQuantity)}%`), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)('グループに含まれている発注情報')), 1),
          _createVNode(EzTable, {
            "grid-template-columns": gridTemplateColumns,
            "sticky-header": "",
            "max-height": "300px",
            "loading-status": loadingStatus.value,
            onRetry: fetchAndInitItem
          }, {
            header: _withCtx(() => [
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('置場コード')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('置場名')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('仕入先コード')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('仕入先名')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('商品コード')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('商品名')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('容量')), 1)
                ], undefined, true),
                _: 1
              }),
              _createVNode(EzHeader, { class: "table__header" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('発注数量')), 1)
                ], undefined, true),
                _: 1
              })
            ]),
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (order, index) => {
                return (_openBlock(), _createBlock(EzTableRow, {
                  id: `orders-row-${index}`,
                  key: order.orderId,
                  "grid-template-columns": gridTemplateColumns,
                  class: "table__row"
                }, {
                  default: _withCtx(() => [
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.warehouseNumber), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.warehouse), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.supplierNumber), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.supplierName), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.businessNumber), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.businessName), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.package), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(EzCell, { class: "table__data" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.orderAmount.addComma()), 1)
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ], undefined, true),
                  _: 2
                }, 1032, ["id"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading-status"])
        ])
      ])
    ])
  ]))
}
}

})